'use strict';

export class MyGlobals {
    daysToGoBack:number=0;
}


// WEBPACK FOOTER //
// ./src/app/globals.ts